import Joi from '@hapi/joi'

export const CashAndBlockSummaryReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Please select valid Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collectionpoint").messages({
        "any.invalid": `Please select valid Collectionpoint`,
        "any.required": `Collectionpoint required`
    }),
    pluckingType: Joi.string().label("pluckingType").messages({
        "any.invalid": `Please select valid plucking Type`,
        "any.required": `plucking Type required`
    }),
    month: Joi.string().invalid("").label("Month").required().messages({
        "any.invalid": `Please select Month`,
        "any.required": `Month required`
    }),
}